import { SET_STORE_REQUEST_DETAILS } from './actionType'

export function setStoreRequestsDetails(details) {
  return {
    type: SET_STORE_REQUEST_DETAILS,
    srDetails: details,
  }
}
